import {commonActions} from '../../actions/commonActions';
import {financeSetList} from '../../actions/financialActions';
import {connect} from 'react-redux';
import List from '../../components/financial/FinanceList';
import {API_FETCH} from '../../services/FetchService';
import {list as bankList} from '../../containers/financial/BankListPage';
import {commonConstants} from "../../constants";


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getBankList : () => {
        return(dispatch(bankList()));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

const list = (value) => {
    return (dispatch, getState) => {
        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('financial/account-document',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(financeSetList(list.data.result));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.financial.list,
        common       : state.common,
        initialValues: state.financial.targetItem,
        bankList  : state.financial.bankList,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);